import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Scrollbars } from 'react-custom-scrollbars';

import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import FormHelperText from '@material-ui/core/FormHelperText';
import Link from '@material-ui/core/Link';

import NewInput from 'components/atoms/NewInput';
import Dialog from 'components/molecules/Dialog';
import NewButton from 'components/molecules/NewButton';
import LoginFooter from 'components/organisms/Footer/LoginFooter';
import FilterCollection from 'components/organisms/FilterCollection';

import MainLogo from 'images/common/logo/logo_black.png';

const useStyles = makeStyles((theme) => ({
  wrap: {
    position: 'fixed !important',
    width: '100%',
    height: '100%',
    '& > div': {
      width: '100%',
      height: '100%',
      paddingBottom: theme.spacing(3),
      backgroundColor: theme.palette.common.gray4,
    },
  },
  formWarp: { marginBottom: theme.spacing(5) },
  paper: {
    maxWidth: 500,
    padding: theme.spacing(6, 2, 4),
    margin: '0px auto',
    backgroundColor: 'transparent',
    boxShadow: 'none',
  },
  container: {
    padding: theme.spacing(1),
    '& > div:first-child': { marginTop: 0 },
  },
  titleBox: {
    textAlign: 'center',
    '& img': { width: '30%', minWidth: 100 },
    '& > h3': {
      marginTop: 15,
      marginBottom: 10,
      fontSize: 22,
      fontWeight: 'bold',
    },
  },
  textField: {
    maxWidth: 'none',
    width: '100%',
    margin: '13px 0 0',
    '& input': { padding: 15 },
  },
  submit: {
    width: '100%',
    marginTop: theme.spacing(2),
    color: '#fff',
    backgroundColor: theme.palette.common.green,
  },
}));

const JoinForm = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const {
    open,
    getParam,
    params,
    onSubmit,
    errorMessage,
    checkUserNo,
    editUserNo,
    error,
    closeCallBack,
  } = props;

  return (
    <>
      <div className={classes.wrap}>
        <Scrollbars autoHide autoHideTimeout={1000} autoHideDuration={200}>
          <div className={clsx('mb-JoinForm', classes.formWarp)}>
            <Paper className={classes.paper}>
              <div className={classes.titleBox}>
                <Link href="/">
                  <img src={MainLogo} alt="logo" />
                </Link>
                <Typography variant="h5" component="h3">
                  {t('회원 기본정보')}
                </Typography>
              </div>
              <form className={classes.container} autoComplete="off">
                <div>
                  <NewInput
                    className={classes.textField}
                    name="userNo"
                    label={t('사번')}
                    params={params}
                    callBack={getParam}
                    value={params.userNo}
                    // error={true}
                    helperText={errorMessage.userNo}
                    required
                    disabled={!!params.userId}
                  />
                  <NewButton
                    onClick={!!params.userId ? editUserNo : checkUserNo}
                    className={classes.submit}
                  >
                    {!!params.userId ? t('사번 수정') : t('사번 검색')}
                  </NewButton>
                </div>
                {!!params.userId && (
                  <>
                    <NewInput
                      className={classes.textField}
                      name="userId"
                      label={t('아이디')}
                      callBack={getParam}
                      value={params.userId}
                      params={params}
                      helperText={errorMessage.userId}
                      required
                      disabled
                    />
                    <NewInput
                      className={classes.textField}
                      name="hiwkId"
                      label={t('하이웍스 아이디')}
                      callBack={getParam}
                      value={params.hiwkId}
                      params={params}
                      helperText={errorMessage.hiwkId}
                      required
                      disabled
                    />
                    <NewInput
                      className={classes.textField}
                      name="userName"
                      label={t('이름')}
                      params={params}
                      callBack={getParam}
                      value={params.userName}
                      helperText={errorMessage.userName}
                      required
                      disabled
                    />
                    <NewInput
                      className={classes.textField}
                      name="email"
                      label={t('사내 이메일 주소')}
                      params={params}
                      callBack={getParam}
                      value={params.email}
                      helperText={errorMessage.email}
                      required
                      disabled
                    />
                    <FormHelperText id="email-helper-text">
                      {t('사내 이메일 주소는 비밀번호 분실 시에도 사용됩니다.')}
                    </FormHelperText>
                    <FilterCollection
                      label={t('계정구분')}
                      name="gubun"
                      params={params}
                      value={params['gubun']}
                      type="select"
                      list={[
                        { label: t('광고주'), value: '11' },
                        { label: t('매체'), value: '13' },
                      ]}
                      callBack={getParam}
                      labelKey="label"
                      valueKey="value"
                    />
                    <NewInput
                      className={classes.textField}
                      name="password"
                      label={t('비밀번호')}
                      params={params}
                      callBack={getParam}
                      value={params.password}
                      error={error.password}
                      helperText={
                        !!error.password && t('비밀번호를 확인해주세요.')
                      }
                      required
                      placeholder={t(
                        '8 ~ 14자 영문 대 소문자, 숫자, 특수문자 조합'
                      )}
                      inputType="password"
                    />
                    <NewInput
                      className={classes.textField}
                      name="confirmPassword"
                      label={t('비밀번호 확인')}
                      params={params}
                      callBack={getParam}
                      value={params.confirmPassword}
                      error={error.confirmPassword}
                      helperText={
                        !!error.confirmPassword && t('비밀번호를 확인해주세요.')
                      }
                      required
                      placeholder={t(
                        '8 ~ 14자 영문 대 소문자, 숫자, 특수문자 조합'
                      )}
                      inputType="password"
                    />
                    <NewInput
                      className={classes.textField}
                      name="phoneNumber"
                      label={t('휴대폰번호')}
                      params={params}
                      callBack={getParam}
                      value={params.phoneNumber}
                      error={error.phoneNumber}
                      placeholder={t('- 제외 숫자만 입력해주세요.')}
                      helperText={
                        !!error.phoneNumber && t('휴대폰번호를 확인해주세요.')
                      }
                      required
                    />
                    <NewButton onClick={onSubmit} className={classes.submit}>
                      {t('등록')}
                    </NewButton>
                  </>
                )}
              </form>
            </Paper>
            <LoginFooter />
          </div>
        </Scrollbars>
      </div>
      <Dialog
        isOpen={open}
        description={t(
          '회원가입이 완료되었습니다.\n로그인 화면으로 이동합니다.'
        )}
        closeCallBack={closeCallBack}
      />
    </>
  );
};

export default JoinForm;
